import { classNames } from 'libs/react';
import { useDebounce } from 'libs/react';
import { useIdent } from 'libs/react';
import { useState } from 'libs/react';
import { useWatch } from 'libs/react';
import { TextInput } from 'components/form/private/inputs/TextInput';
import { Icon } from 'components/Icon';
import { React } from 'libs/react';
import './TableSearch.scss';
/**
 * @component TableSearch
 * @since 1.0.0
 */
export function TableSearch(props) {
    const { name, size, style, scale, required, disabled, placeholder, autoselect, autocorrect, autocomplete, autocapitalize } = Object.assign({ size: 'small', name: '', style: 'normal', placeholder: t('Search') }, props);
    const [ident] = useIdent('table-search');
    const [value, setValue] = useState(props.value || props.defaultValue || '');
    const [focused, setFocused] = useState(false);
    // Update value when prop changes
    React.useEffect(() => {
        if (props.value !== undefined) {
            setValue(props.value);
        }
        else if (props.defaultValue !== undefined) {
            setValue(props.defaultValue);
        }
    }, [props.value, props.defaultValue]);
    const onSearchDebounced = useDebounce(props.onSearch, 500);
    /**
     * @function onBlur
     * @since 1.0.0
     * @hidden
     */
    function onBlur() {
        setFocused(false);
    }
    /**
     * @function onFocus
     * @since 1.0.0
     * @hidden
     */
    function onFocus() {
        setFocused(true);
    }
    /**
     * @function onChange
     * @since 1.0.0
     * @hidden
     */
    function onChange(value) {
        setValue(value);
    }
    /**
     * @function onCancel
     * @since 1.0.0
     * @hidden
     */
    function onClear() {
        setValue('');
    }
    useWatch(() => {
        onSearchDebounced(value);
    }, [value]);
    const className = classNames('table-search', 'table-search--' + size, 'table-search--' + style, { 'table-search--is-required': required }, { 'table-search--is-disabled': disabled }, { 'table-search--is-focused': focused }, { 'table-search--has-value': value !== '' }, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "table-search-field" },
            React.createElement("div", { className: "table-search-button-wrapper" },
                React.createElement("div", { className: "table-search-button table-search-button--search" },
                    React.createElement(Icon, { className: "table-search-picto", value: "search" })),
                React.createElement("div", { className: "table-search-button table-search-button--clear", onClick: onClear },
                    React.createElement(Icon, { className: "table-search-picto", value: "times" }))),
            React.createElement(TextInput, { name: name, type: "text", ident: ident, value: value, scale: scale, required: required, disabled: disabled, placeholder: placeholder, autoselect: autoselect, autocorrect: autocorrect, autocomplete: autocomplete, autocapitalize: autocapitalize, onBlur: onBlur, onFocus: onFocus, onChange: onChange }))));
}
